import {
  SET_USER_MESSAGE_LIST,
  SET_USER_MESSAGE_LIST_PAGE,
  SET_USER_MESSAGE_LIST_PAGE_TOTAL,
  SET_USER_MESSAGE_LIST_PAGE_SIZE,
  SET_DISTRIBUTE_DIALOG,
  SET_PLATFORM_USER_MESSAGE,
  SET_AGENCY_CHOISE,
  SET_USER_MESSAGE_LIST_SORT,
  CHAHE_USER_MESSAGE_LIST_QUERY,
  SET_USER_MESSAGE_LIST_SEARCHING,
  RESET_USER_LIST_QUERY,
  SET_ASSIGN_SALESPERSONS_DATA_LIST,
  SET_ASSIGN_SALESPERSONS_DATA_LIST_QUERY,
  SET_ASSIGN_SALESPERSONS_DATA_LIST_SEARCHING,
  SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_TOTAL,
  SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_NUM,
  SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_SIZE,
} from './mutation-types'
import _ from 'lodash'
import files from 'file-saver'
import api from '@/api'
import {getHeaderName, objectTrim} from '@/utils'
import { checkUserName } from '@/views/User/utils'
import { AuthTypeList } from '@/constants/filters'

const viewDataInitQuery = () => ({
  pageNum: 1,
  pageSize: 50,
})

const initQuery = () => {
  return {
    pageNum: 1,
    pageSize: 50,
    userId: '',               // Long 否 用户id
    userName: '',             // String 否 用户名
    phone: '',                // String 否 用户手机
    email: '',                // String 否 用户邮箱
    userScale: '',            // int 否 用户规模1:SME 为小客户，2:KA 为 大客户
    // areaId: [],               // Long 否 所属区域id
    zone: '',                 // Integer 否 客户国内外区域 （1.国内 2.国外）
    isZombie: '',             // Integer 否 是否为僵尸用户 (0.不是 1.是)
    country: '',              // String 否 所属国家
    company: '',              // String 否 公司名
    city: '',                 // String 否 所属城市
    fromWhere: '',            // String 否 来源
    adminId: '',              // Long 否 业务员id(分配给用户的后台管理员)
    registerStartTimeStamp: '',    // Date 否 注册时间开始（时间戳）
    registerEndTimeStamp: '',      // Date 否 注册时间结束（时间戳）
    agentId: '',              // Long 否 代理商id(分配给用户的后台管理员)
    taskProperties: '',       // String 否 任务默认属性
    taskRequirements: '',     // String 否 任务默认要求
    taskGroup: '',            // String 否 任务默认群组
    unallocatedPC: '',        // boolean 否 待分配PC
    unallocatedTD: '',        // boolean 否 待分配TD
    unallocatedSalesman: '',  // boolean 否 待分配业务员
    businessType: '',         // int 否 业务类型(0 效果图 1 动画)
    lever: '',                // int 否 客户vip级别
    pictureLever: '',         // int 否 客户效果图等级(0 普通版 1专业版)
    role: '',
    remark: '',
    displaySubaccount: '',
    inviterId: '',            // 邀请人id
    queryAdminId: '',         // 管理员 id
    balanceRangeStart: '',
    balanceRangeEnd: '',
    // authStatus: '',
    registerSourceFlag: '',
    isDeleted: '',
    isFirstReCharge: '',
    isFirstSubmit: '',
    fatherUuid: '',
    enabled: '',
    accountType: '',
    isInternalTestAccount: '',
    sourceType: '',
    registerType: '',
    loginStartTimeStamp: '',    // 最近登录时间开始（时间戳）
    loginEndTimeStamp: '',      // 最近登录时间结束（时间戳）
    pcAdminId: '',              // Long 否 pc id(分配给用户的后台管理员)
    registerSource: '',         // 注册来源
    ip: '',
    // accountType: '',           // int 是 账号类型(主子账号1.主账号 2.子账号)
    // registerDate: '',          // Date 否 注册时间
    // orderByLoginDate: '',      // int 否 1：按最近登录时间login_date升序排序 0：按最近登录时间login_date降序排序
    // orderByRegisterDate: '',   // int 否 1：按注册时间register_date:升序排序 0 / 默认（不传）按注册时间register_date降序排序
  }
}
const queryAdminByOrganizationType = () => {
  return {                   // 通过组织类型查找管理员
    loginName: '',           // 登录名
    reallyName: '',          // 名字全称
  }
}
const state = {
  searching: false,
  initQuery: initQuery(),
  queryAdmin: queryAdminByOrganizationType(),
  userMessage: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
    sort: {},
  },
  platformUserMessage: {
    userId: '',
    userName: '',
    accountType: '',
    accountMsg: [],
    query: {},
  },
  agentList: [],
  assignSalespersonsListLoading: false,
  assignSalespersonData: {
    list: [],
    listPageTotal: 0,
    query: viewDataInitQuery(),
  },
}

const mutations = {
  [SET_USER_MESSAGE_LIST] (state, payload) {
    state.userMessage.list = payload
  },
  [SET_USER_MESSAGE_LIST_PAGE] (state, payload) {
    state.userMessage.query.pageNum = payload
  },
  [SET_USER_MESSAGE_LIST_PAGE_TOTAL] (state, payload) {
    state.userMessage.listPageTotal = payload
  },
  [CHAHE_USER_MESSAGE_LIST_QUERY] (state, payload) {
    state.userMessage.query = {
      ...state.userMessage.query,
      ...payload,
    }
  },
  [SET_DISTRIBUTE_DIALOG] (state, payload) {
    state.dialog.distribute = {
      ...state.dialog.distribute,
      ...payload,
    }
  },
  [SET_USER_MESSAGE_LIST_PAGE_SIZE] (state, payload) {
    state.userMessage.query.pageSize = payload
  },
  [SET_PLATFORM_USER_MESSAGE] (state, payload) {
    state.platformUserMessage = payload
  },
  [SET_AGENCY_CHOISE] (state, payload) {
    state.agentList = payload
  },
  [SET_USER_MESSAGE_LIST_SORT] (state, payload) {
    state.userMessage.sort = payload
  },
  [SET_USER_MESSAGE_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [RESET_USER_LIST_QUERY] (state, payload) {
    state.userMessage.query = payload
  },
  [SET_ASSIGN_SALESPERSONS_DATA_LIST] (state, payload) {
    state.assignSalespersonData.list = payload
  },
  [SET_ASSIGN_SALESPERSONS_DATA_LIST_QUERY] (state, payload) {
    state.assignSalespersonData.query = {
      ...state.assignSalespersonData.query,
      ...payload,
    }
  },
  [SET_ASSIGN_SALESPERSONS_DATA_LIST_SEARCHING] (state, payload) {
    state.assignSalespersonsListLoading = payload
  },
  [SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_TOTAL] (state, payload) {
    state.assignSalespersonData.listPageTotal = payload
  },
  [SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_NUM] (state, payload) {
    state.assignSalespersonData.query.pageNum = payload
  },
  [SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_SIZE] (state, payload) {
    state.assignSalespersonData.query.pageSize = payload
  },
}

const actions = {
  // 用户标签列表
  async getUserTagList ({commit}) {
    const {data} = await api.userApi.getUserTagList()
    return data
  },
  // 新版用户标签列表
  async newGetUserTagList ({commit}) {
    const {data} = await api.userApi.newGetUserTagList()
    return data
  },
  // 列表页顶部添加用户标签（可多选用户）
  async addUserLabel ({commit}, payload) {
    const {code, message} = await api.userApi.addUserLabel(payload)
    return {code, message}
  },
  // 获取用户列表
  async setUserMessageList ({ commit, state, dispatch }, payload) {
    try {
      let params = {
        ...state.userMessage.sort,
        ...state.userMessage.query,
        ...payload,
      }
      // 0 或者 空值 为全部 1 为主账号 2 为子账号 3 为钉钉账号
      //  accountType = 3时 传参为2 isDingTalk = 1
      //  0 或者 空 都不传
      if (params.accountType !== 0 && params.accountType) {
        params = {
          ...params,
          accountType: params.accountType === 1 ? 1 : 2,
          isDingTalk: params.accountType === 3 ? 1 : 0,
        }
      }
      if (params['authStatus'] && params['authStatus'].length) {
        params['authStatus'].includes(AuthTypeList.EnterpriseUnderReview) && (params['authStatus'] = [...params['authStatus'], AuthTypeList.PersonUnderReview])
        params['authStatus'].includes(AuthTypeList.PersonalAuthFailed) && (params['authStatus'] = [...params['authStatus'], AuthTypeList.EnterpriseAuthFail])

        // 个人认证
        params['authStatus'].includes(AuthTypeList.PERSONALVERIFIED) && (params['authStatus'] = [...params['authStatus'], AuthTypeList.PersonaChangeFailed, AuthTypeList.PersonalToEnterpriseFailed])
        // 企业认证
        params['authStatus'].includes(AuthTypeList.ENTERPRISEVERIFIED) && (params['authStatus'] = [...params['authStatus'], AuthTypeList.EnterpriseChangeFailed])
        // 变更中
        params['authStatus'].includes(AuthTypeList.CHANGING) && (params['authStatus'] = [...params['authStatus'], AuthTypeList.PersonalChanging])
      }
      if (payload && !params.userName && payload.userName) {
        delete params.userName
      }
      const {data, code} = await api.userApi.getUserList(objectTrim(params))
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = params
          dispatch('setUserMessageList', {
            ...objectTrim(other),
            userId,
          })
        },
      })
      commit(SET_USER_MESSAGE_LIST_SEARCHING, false)
      commit(SET_USER_MESSAGE_LIST_PAGE_TOTAL, data.total)
      commit(SET_USER_MESSAGE_LIST, data.items)
    } catch (error) {
      commit(SET_USER_MESSAGE_LIST_SEARCHING, false)
      commit(SET_USER_MESSAGE_LIST, [])
      commit(SET_USER_MESSAGE_LIST_PAGE_TOTAL, 0)
    }
  },
  // 用户列表改变页码
  async changeUserMessageLsitPage ({commit, state, dispatch}, payload) {
    commit(SET_USER_MESSAGE_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setUserMessageList')
  },
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_USER_MESSAGE_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeUserMessageLsitPage', {currentPage: 1})
  },
  // 用户列表筛选
  changeUserMessageLsitQuery ({commit, state, dispatch}) {
    commit(SET_USER_MESSAGE_LIST_SEARCHING, true)
    dispatch('changeUserMessageLsitPage', {currentPage: 1})
  },
  // 重置筛选参数
  resetUserListQuery ({commit, state}) {
    commit(RESET_USER_LIST_QUERY, state.initQuery)
  },
  // 用户列表导出用户excel表
  async exportUserList ({state, dispatch}, payload) {
    const query = objectTrim(state.userMessage.query)
    const params = {
      ...query,
      ...payload,
    }
    if (payload && payload.userId && params.userName) {
      delete params.userName
    }
    return api.userApi.exportUserList(params)
  },
  changeUserListQuery ({commit}, payload) {
    commit(CHAHE_USER_MESSAGE_LIST_QUERY, payload)
  },
  // 用户列表导出手机excel表
  async exportPhone ({state}) {
    const query = objectTrim(state.userMessage.query)
    const {data, headers} = await api.userApi.exportPhone(query)
    const fileName = getHeaderName(headers)
    const blob = new Blob([data], { type: 'application/zip' })
    files.saveAs(blob, fileName)
    return blob
  },
  // 根据类型获取管理员名单
  async getAdminByOrganization ({state, commit}, payload) {
    const query = {
      ...state.queryAdmin,
      ...payload,
    }
    const {data} = await api.userApi.queryAdminByOrganizationType(query)
    if (query.organizationType === 4) {
      commit(SET_AGENCY_CHOISE, data)
    }
    return data
  },
  // 分配管理员
  async distributeAdmin ({dispatch}, payload) {
    try {
      const {code, message} = await api.userApi.allocateUserAdmin(payload)
      /* eslint-disable */
      if (code===200) {
        vm.$message.success(message)
        const {adminIds, adminNames, userId, organizationType} = payload
        const adminList = adminIds.map((v, index) =>({
          adminId: v,
          reallyName: adminNames[index],
          userId
        }))
        let distributeList
        switch (organizationType) {
          case 11:
            distributeList = {allocatedSalesmanList: adminList}
            break
          case 12:
            distributeList = {allocatedSalesmanList: adminList}
            break
          case 125:
            distributeList = {allocatedSalesmanList: adminList}
            break
          case 2:
            distributeList = {allocatedPCList: adminList}
            break
          case 3:
            distributeList = {allocatedTDList: adminList}
            break
          case 4:
            distributeList = {allocatedAgent: adminList}
            break
        }
        vm.$store.dispatch('user/userInfo/changeUserInfo', distributeList)
      }
    } catch (e) {
      console.log(e)
    }
  },
  async changeUserAdmin ({commit, state, dispatch}, payload) {
    const {code, message} = await api.userApi.moveUser(payload)
    return {code, message}
  },
  // 停用账号
  async setStatus ({}, payload) {
    const {code, message} = await api.userApi.enabledUser(payload)
    return {code, message}
  },
  // 添加备注
  async addRemark ({}, payload) {
    const {status} = await api.userApi.addRemark(payload)
    return {status}
  },
  // 标记僵尸
  async markZombies ({}, payload) {
    const {code, message} = await api.userApi.markZombies(payload)
    return {code, message}
  },
  //平台用户信息展示
  async platformUserMsg ({commit}, payload) {
    try{
      const query = payload
      const userId = payload.userId
      const {code, message, data} = await api.userApi.getOldPlatformUserInfo(payload)
      if (data === null || JSON.stringify(data) === '{}') {
        commit(SET_PLATFORM_USER_MESSAGE, {userId, query})
      } else {
        const userIds = Object.keys(data)
        const userMsgs = Object.values(data)
        const currentAccount = userMsgs[userIds.indexOf("" + userId)]
        const accountMsg = []
        userMsgs.forEach((item) => {
          let obj = {}
          obj.ID = item.ID
          obj.userName = item.LOGIN_NAME
          obj.type = item.CUST_TYPE
          obj.zone = item.ZONE
          obj.balance = item.CURRENCY_BALANCE + item.CURRENCY
          obj.coupon = (item.COUPON < 0) ? (item.COUPON = 0) : item.COUPON_BALANCE
          obj.qingyunCoupon = (item.QINGYUNCOUPON < 0) ? (item.QINGYUNCOUPON = 0) : item.QCOUPON_BALANCE
          accountMsg.push(obj)
        })
        const userName = currentAccount.LOGIN_NAME
        const accountType = currentAccount.CUST_TYPE
        commit(SET_PLATFORM_USER_MESSAGE, {userId, userName, accountType, accountMsg, query})
      }
      return {code, message}
    } catch (error){
      console.log('error: ', error)
      return false
    }
  },
  // 平台用户导入
  async transferPlatformUser ({}, payload) {
    const {message, result, code} = await api.userApi.synchronizeUserById(payload)
    return {message, result, code}
  },
  initPlatformUserMsg ({commit}, payload) {
    commit(SET_PLATFORM_USER_MESSAGE, {
      userId:'',
      userName: '',
      accountType: '',
      accountMsg: [],
      query: {},
    })
  },
  // 重置排序
  resetUserListSort ({dispatch}) {
    dispatch('changeUserListSort', {})
  },
  changeUserListSort ({commit, dispatch}, payload) {
    commit(SET_USER_MESSAGE_LIST_SORT, payload)
    dispatch('changeUserMessageLsitPage', {currentPage: 1})
  },
  // 激活用户
  async activateAccounts({dispatch}, payload) {
    const {code} = await api.userApi.activeUser({userId: payload})
    if (code === 200) {
      vm.$message.success(vm.$t('user_active_success'))
      dispatch('setUserMessageList')
    }
  },
  // 删除用户
  async deleteUserAccount({dispatch}, payload) {
    const {code, message} = await api.userApi.deleteUser(payload)
    return {code: code, message: message}
  },
  // 导出用户月消费清单
  async exportUserMonthConsumeList({dispatch}, payload) {
    const {data, headers} = await api.userApi.exportUserMonthConsumeList(payload)
    try {
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/zip' })
      files.saveAs(blob, fileName)
      return blob
    } catch (error) {
      const reader = new FileReader()
      reader.onload = () => {
        const result = JSON.parse(reader.result)
        const { code, data } = result
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            const { userName, ...other } = payload
            dispatch('exportUserMonthConsumeList', {
              ...other,
              exportUserIds: [userId],
            })
          },
        })
      }
      reader.readAsText(res.data)
    }
  },
  // 上传-批量分配业务员
  async uploadBatchAssignSalesperson({ state }, payload) {
    const data = await api.userApi.uploadBatchAssignSalesperson(payload)
    return data
  },
  async setAssignSalespersonList ({commit, state, dispatch}, payload) {
    try {
      let query = {}
      _.forIn(state.assignSalespersonData.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageNum: state.assignSalespersonData.query.pageNum,
        pageSize: state.assignSalespersonData.query.pageSize,
        ...payload,
      }
      const {data, code} = await api.userApi.getBatchAssignSalespersonList(params)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = params
          dispatch('setAssignSalespersonList', {
            ...other,
            userId,
          })
        },
      })
      const {items, total} = data
      commit(SET_ASSIGN_SALESPERSONS_DATA_LIST_SEARCHING, false)
      commit(SET_ASSIGN_SALESPERSONS_DATA_LIST, items)
      commit(SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_ASSIGN_SALESPERSONS_DATA_LIST_SEARCHING, false)
      commit(SET_ASSIGN_SALESPERSONS_DATA_LIST, [])
      commit(SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_TOTAL, 0)
    }
  },
  initAssignSalespersonList ({dispatch}) {
    dispatch('setAssignSalespersonList')
  },
  async changeListPage ({commit, dispatch}, payload) {
    commit(SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_NUM, payload.currentPage)
    dispatch('setAssignSalespersonList')
  },
  changeSalepersonsPageSize ({commit, dispatch}, payload) {
    commit(SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeListPage', {currentPage: 1})
  },
  setAssignSalespersonListQuery ({commit, dispatch}, payload) {
    commit(SET_ASSIGN_SALESPERSONS_DATA_LIST_QUERY, payload)
  },
  // 下载批量分配业务员失败接口
  async downloadBatchAssignSalespersonFailedData ({commit}, payload) {
    const res = await api.userApi.downloadBatchAssignSalespersonFailedData(payload)
    const {data, headers} = res
    try {
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      console.log(e)
      const reader = new FileReader()
      reader.onload = () => {
        const result = JSON.parse(reader.result)
        const { code, data } = result
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            const { userName, ...other } = params
            dispatch('exportExcel', {
              ...other,
              userId,
            })
          },
        })
      }
    }
  },
  // 上传匹配邮箱
  async uploadMatchEmailInfo({ state }, payload) {
    const data = await api.userApi.uploadMatchEmailInfo(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
